import ProjectService from '@/services/projects/project-service'
import { alertSuccess } from '@/utilities/sweetalert'

export const state = {
  projects: [],
  project: {},
  loading: {
    projects: false,
    projectById: null,
    members: false,
    memberById: null
  }
}

export const getters = {
  projects: state => state.projects,
  project: state => state.project,
  loading: state => state.loading
}

export const actions = {
  fetchProjects({ commit }) {
    commit('SET_PROJECTS_LOADING', true)

    ProjectService.index()
      .then(response => {
        commit('SET_PROJECTS', response.data)
      })
      .catch(() => {
        commit('SET_PROJECTS', [])
      })
      .then(() => {
        commit('SET_PROJECTS_LOADING', false)
      })
  },

  fetchProject({ commit }, id) {
    commit('SET_PROJECT_BY_ID_LOADING', id)

    ProjectService.show(id)
      .then(response => {
        commit('SET_PROJECT', response.data)
      })
      .catch(() => {
        commit('SET_PROJECT', {})
      })
      .then(() => {
        commit('SET_PROJECT_BY_ID_LOADING', null)
      })
  },

  storeProject({ commit }, payload) {
    commit('SET_PROJECTS_LOADING', true)

    ProjectService.store({
      name: payload.name,
      description: payload.description,
      wiki: payload.wiki,
      customer_id: payload.customer_id
    })
      .then(response => {
        commit('INSERT_PROJECT_TO_PROJECTS', response.data) // TODO - replace response with single project

        alertSuccess({
          title: 'Project successfully created.'
        })
      })
      .catch(() => {
        commit('SET_PROJECT', {})
      })
      .then(() => {
        commit('SET_PROJECTS_LOADING', false)
      })
  },

  updateProject({ commit }, payload) {
    commit('SET_PROJECT_BY_ID_LOADING', payload.id)

    ProjectService.update(payload.id, {
      name: payload.name,
      description: payload.description,
      wiki: payload.wiki,
      customer_id: payload.customer_id
    })
      .then(response => {
        commit('SET_PROJECT', response.data)

        alertSuccess({
          title: 'Project successfully updated.'
        })
      })
      .catch(() => {})
      .then(() => {
        commit('SET_PROJECT_BY_ID_LOADING', null)
      })
  },

  updateProjectMembers({ commit }, payload) {
    commit('SET_MEMBERS_LOADING', true)

    ProjectService.assignMembers(payload.id, payload.members)
      .then(response => {
        commit('SET_PROJECT', response.data)

        alertSuccess({
          title: 'Members successfully assigned.'
        })
      })
      .catch(() => {})
      .then(() => {
        commit('SET_MEMBERS_LOADING', false)
      })
  },

  removeProjectMember({ commit }, payload) {
    commit('SET_MEMBER_BY_ID_LOADING', payload.user_id)

    ProjectService.removeMember(payload.project_id, payload.user_id)
      .then(response => {
        commit('SET_PROJECT', response.data)

        alertSuccess({
          title: 'Member successfully removed.'
        })
      })
      .catch(() => {})
      .then(() => {
        commit('SET_MEMBER_BY_ID_LOADING', false)
      })
  },

  downloadDocument(_, payload) {
    ProjectService.downloadDocument(payload.project_id, payload.file_name)
  }
}

export const mutations = {
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  SET_PROJECT(state, project) {
    state.project = project
  },
  SET_PROJECTS_LOADING(state, loading) {
    state.loading.projects = loading
  },
  SET_PROJECT_BY_ID_LOADING(state, id) {
    state.loading.projectById = id
  },
  SET_MEMBERS_LOADING(state, loading) {
    state.loading.members = loading
  },
  SET_MEMBER_BY_ID_LOADING(state, id) {
    state.loading.memberById = id
  },
  INSERT_PROJECT_TO_PROJECTS(state, project) {
    state.projects.push(project)
  },
  INSERT_TASK_LIST_TO_PROJECT(state, taskList) {
    if (!state.project || !state.project.task_lists) return

    state.project.task_lists.push(taskList)
  },
  INSERT_TASK_TO_PROJECT_TASK_LIST(state, task) {
    if (!state.project || !state.project.task_lists) return

    state.project.task_lists
      .find(taskList => taskList.id == task.task_list.id)
      .tasks.push(task)
  },
  UPDATE_TASK_IN_PROJECT_TASK_LIST(state, task) {
    if (!state.project || !state.project.task_lists) return
    const taskListIndex = state.project.task_lists.findIndex(
      projectTaskList => projectTaskList.id === task.task_list.id
    )

    if (!state.project.task_lists[taskListIndex]) return

    const taskIndex = state.project.task_lists[taskListIndex].tasks.findIndex(
      projectTask => projectTask.id === task.id
    )

    if (!state.project.task_lists[taskListIndex].tasks[taskIndex]) return

    Object.assign(
      state.project.task_lists[taskListIndex].tasks[taskIndex],
      task
    )
  },
  REMOVE_TASK_LIST_FROM_PROJECT(state, id) {
    if (!state.project || !state.project.task_lists) return

    state.project.task_lists = state.project.task_lists.filter(
      taskList => taskList.id !== id
    )
  },
  REMOVE_TASK_FROM_PROJECT_TASK_LIST(state, id) {
    if (
      !state.project ||
      !state.project.task_lists ||
      !state.project.task_lists.tasks
    )
      return

    state.project.task_lists.tasks = state.project.task_lists.tasks.filter(
      task => task.id !== id
    )
  }
}
